import { AdditionalSearchType, HeaderSearchSelection } from '@upright/common/model/search/types';
import { useState } from 'react';

export function useHeaderSearchTypeSelection(initialSearchType?: HeaderSearchSelection) {
  const [headerSearchType, setHeaderSearchType] = useState<HeaderSearchSelection>(
    initialSearchType ?? AdditionalSearchType.ALL,
  );
  return { headerSearchType, setHeaderSearchType };
}
